'use memo'

import { useUserPlayersQuery } from '@sportninja/common/hooks/useUserPlayersQuery'
import { useProfileHighlights } from '../../../../../features/profile/hooks/useProfileHighlights'
import { PlayerHighlight } from '../../../../Player/types'

const MAX_ITEMS = 6

interface UseHomeHighlightsResult {
  latestSix: PlayerHighlight[]
  isVisible: boolean
}

export const useHomeHighlights = (): UseHomeHighlightsResult => {
  const { playerIds, isPending: playersPending } = useUserPlayersQuery()
  const playersLoaded = !playersPending
  const { highlights, loading: highlightsLoading } = useProfileHighlights(
    playerIds,
    playersLoaded && playerIds.length > 0
  )

  const latestSix = [...highlights]
    .filter((highlight) => Boolean(highlight.video_url))
    .slice(0, MAX_ITEMS)

  const isVisible =
    !playersPending && !highlightsLoading && latestSix.length > 0

  return { latestSix, isVisible }
}
